import { AdminAuditLogListResponse } from "@/service/response/admin-audit-logs";
import { gridLayout } from "./LogsListHeader";
import { cn } from "@/libs/cn";
import { GridTableCell } from "@/modules/common/components/files/GridTable";
import { Tooltip } from "@/modules/common/components";
import { dayjsExtension } from "@/utils/days";
import { formatNameInitials } from "@/modules/common/utils/format";
import { generatePath, Link } from "react-router-dom";
import { ROUTES } from "@/routes/constants/routes";

interface LogsListLineParams {
  log: AdminAuditLogListResponse;
}

const LogsListLine = ({ log }: LogsListLineParams) => {
  return (
    <Link
      to={generatePath(ROUTES.LOGS.DETAILS, { id: log.id })}
      className={cn(
        gridLayout,
        "bg-white border border-[#D6DEE9] md:rounded-none md:border-0 md:border-t md:bg-transparent rounded-lg hover:bg-ui-hover transition-colors",
      )}
    >
      <GridTableCell label="Usuário" className="md:min-w-0">
        {log.performedByName === null ? (
          "-"
        ) : (
          <div className="flex items-center gap-2 md:min-w-0">
            <div className="flex items-center justify-center rounded-full bg-blue-800/10 text-blue-800 text-sm font-semibold h-8 w-8 shrink-0">
              {formatNameInitials(log.performedByName)}
            </div>
            <Tooltip label={log.performedByName}>
              <p className="wrap-break-word md:min-w-0 md:block md:truncate text-sm">{log.performedByName}</p>
            </Tooltip>
          </div>
        )}
      </GridTableCell>

      <GridTableCell label="Operação" className="md:min-w-0">
        <Tooltip label={log.operation_translated} disabled={!log.operation_translated}>
          <p className="wrap-break-word md:block md:truncate text-sm">{log.operation_translated ?? "-"}</p>
        </Tooltip>
      </GridTableCell>

      <GridTableCell label="Origem" className="md:min-w-0">
        <Tooltip label={log.path} disabled={!log.path}>
          <p className="wrap-break-word md:block md:truncate text-sm">{log.path ?? "-"}</p>
        </Tooltip>
      </GridTableCell>

      <GridTableCell label="Data">
        <p className="whitespace-nowrap text-sm">{dayjsExtension(log.createdAt).format("YYYY - MM - DD - HH:mm")}</p>
      </GridTableCell>
    </Link>
  );
};

export default LogsListLine;
